import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import {IconButton} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import Swal from "sweetalert2";
import {apiCall} from "../../helpers/MainHelper";
import withPermissions from "../WithPermissions";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";
class KsoftServiceInvoicesTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending:true
        }
    }

    getExtraQueryParams() {
        const { status } = this.props;
        if (status) {
            return { status: status };
        }
        return {};
    }
    handleDelete = async (invoiceID) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    await apiCall('business/ksoft/delete-invoice/'+invoiceID,'delete');
                    await this.triggerFetch();
                    Swal.close();
                } catch (error) {
                    Swal.close();
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                    Swal.close();
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Silindi!',
                    'Fatura başarıyla silindi.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Fatura silinemedi.Lütfen daha sonra tekrar deneyiniz.',
                    'error'
                );
            }
        }
    }
    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };
    handleInvoiceDetail = (invoiceId) => {
        // ✅ YENİ: Direkt invoice_id ile detaya git (createTempInvoice çağrılmaz)
        this.props.history.push(`/invoice-detail/${invoiceId}`);
    }
    render() {
        const {pending} = this.state;
        const {userPermissions} = this.props;
        const userHasViewCustomerPermission = userPermissions.includes('view customer');
        const userHasDeleteCustomerPermission = userPermissions.includes('delete customer');
        const columns = [
            {
                name:'ID',
                selector:row => row.id,
                sortable:true
            },
            {
                name:'Fatura No',
                selector:row => row.documentId
            },
            {
                name:'Tutar',
                selector:row => row.total_with_vat,
            },

            {
                name:'Plaka',
                selector:row => row.plate?.toUpperCase(),
                sortable:true
            },
            {
                name:'Müşteri',
                selector:row => (row.customer?.name?.toUpperCase()+' '+row.customer?.surname?.toUpperCase()) || row.customer?.title?.toUpperCase(),
                sortable:true
            },
            {
                name: 'Durum',
                cell: row => {
                    const statusConfig = {
                        draft: { text: 'Taslak', class: 'badge-primary', icon: 'icon-note' },
                        running: { text: 'İşlemde', class: 'badge-warning', icon: 'icon-clock' },
                        done: { text: 'Tamamlandı', class: 'badge-success', icon: 'icon-check' },
                        cancel: { text: 'İptal', class: 'badge-danger', icon: 'icon-close' },
                        error: { text: 'Hatalı', class: 'badge-danger', icon: 'icon-exclamation' },
                        unknown: { text: 'Belirsiz', class: 'badge-secondary', icon: 'icon-question' }
                    };
                    const status = statusConfig[row.status] || statusConfig.unknown;
                    return (
                        <span className={`badge ${status.class}`}>
                            <i className={status.icon}></i> {status.text}
                        </span>
                    );
                },
                sortable: true
            },

            {
                name: 'İşlem',
                button: true,
                cell: row => (
                    <>

                    {userHasDeleteCustomerPermission ? (
                        <IconButton className="btn btn-outline-secondary" onClick={() => this.handleDelete(row.id)} style={{cursor: 'pointer',marginLeft:-15}}>
                            <button type="button" className="btn btn-outline-danger btn-sm" ><i className="icon-trash"></i></button>
                        </IconButton>
                    ):""}


                    </>
                )}

        ]
        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint="business/ksoft/service"
                extraQueryParams={this.getExtraQueryParams()}
                columns={columns}
                onRowClicked={userHasViewCustomerPermission ? row => this.handleInvoiceDetail(row.id) : undefined}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withPermissions(withRouter(KsoftServiceInvoicesTable));
